module.exports = __webpack_public_path__ + "img/img-yb.98c37ea.png";